module.exports = __webpack_public_path__ + "assets/img/footer_sample_book.70530e47.svg";